import { SibBaseObject } from "../BaseObject/SibBaseObject";

export class Country extends SibBaseObject {
    countryCode: string;
    countryName: string;
    isoNumber: string;
    isoAlpha3: string;
    fipsCode: string;
    countryKey: string = "1269750";
}